export default {
  applyToVersions: "<2.6.0",
  type: "before",
  name: "move resources to net positions",
  migrate(data) {
    if (!data.resources) {
      return data;
    }

    const order = data.resources.order;
    const W = 200; // standard resource width
    const G = 20; // standard gap between resources
    const H = 100;

    let elementBottom = 0;
    let elementLeft = 0;
    
    const elements = Object.values(data.elements?.items || {});

    elements.forEach((element) => {
      elementBottom = Math.max(elementBottom, element.bottom);
      elementLeft = Math.min(elementLeft, element.left);
    });

    for (const resourceId in data.resources.items) {
      const resource = data.resources.items[resourceId];
      if (resource.x != null) break;
      const orderIndex = order.indexOf(resource.id);
      resource.x = elementLeft + (W + G) * orderIndex;
      if (resource.y == null) resource.y = elementBottom + G;

      resource.left = resource.x;
      resource.top = resource.y;
      if (resource.width == null) resource.width = W;
      if (resource.height == null) resource.height = H;
      resource.right = resource.left + resource.width;
      resource.bottom = resource.top + resource.height;

      resource.center = {
        x: resource.left + resource.width / 2,
        y: resource.top + resource.height / 2
      };
    }

    return data;
  }
};
